import type { IconSelectOption } from "../../components/forms/IconAutocomplete";
import { withI18nKeys } from "../i18n/optionLabel";

export const ENTITY_STATUS_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "ACTIVE", label: "Active", icon: "check_circle" },
    { value: "PASSIVE", label: "Passive", icon: "pause_circle" },
  ],
  "options.entityStatus",
);

export const CUSTOMER_STATUS_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "ACTIVE", label: "Active", icon: "check_circle" },
    { value: "INACTIVE", label: "Inactive", icon: "cancel" },
    { value: "SUSPENDED", label: "Suspended", icon: "block" },
  ],
  "options.customerStatus",
);

export const CONTACT_TYPE_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "PHONE", label: "Phone", icon: "phone" },
    { value: "MOBILE", label: "Mobile", icon: "smartphone" },
    { value: "EMAIL", label: "Email", icon: "email" },
    { value: "OTHER", label: "Other", icon: "more_horiz" },
    { value: "SIEM", label: "SIEM", icon: "security" },
    { value: "BACKUP", label: "Backup", icon: "backup" },
    { value: "FIREWALL", label: "Firewall", icon: "local_fire_department" },
    { value: "EPP", label: "EPP", icon: "shield" },
    { value: "XDR", label: "XDR", icon: "radar" },
    { value: "DLP", label: "DLP", icon: "lock" },
    { value: "ISP", label: "ISP", icon: "router" },
    { value: "FILE_AUDIT", label: "File Audit", icon: "folder_open" },
    { value: "MONITORING_TOOL", label: "Monitoring", icon: "monitor_heart" },
  ],
  "options.contactType",
);

export const INCIDENT_STATUS_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "NEW", label: "New", icon: "fiber_new" },
    { value: "ASSIGNED", label: "Assigned", icon: "person_add" },
    { value: "IN_PROGRESS", label: "In Progress", icon: "autorenew" },
    { value: "ON_HOLD", label: "On Hold", icon: "pause_circle" },
    { value: "RESOLVED", label: "Resolved", icon: "task_alt" },
    { value: "CLOSED", label: "Closed", icon: "lock" },
    { value: "CANCELLED", label: "Cancelled", icon: "cancel" },
  ],
  "options.incidentStatus",
);

export const COMMENT_TYPE_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "UPDATE", label: "Update", icon: "update" },
    { value: "RESOLUTION", label: "Resolution", icon: "task_alt" },
    { value: "ESCALATION", label: "Escalation", icon: "trending_up" },
    { value: "SYSTEM", label: "System", icon: "settings" },
  ],
  "options.commentType",
);

export const ASSIGNMENT_TYPE_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "user", label: "Assign to Me", icon: "person" },
    { value: "group", label: "Assign to Group", icon: "groups" },
  ],
  "options.assignmentType",
);

export const DURATION_TYPE_OPTIONS: IconSelectOption[] = withI18nKeys(
  [
    { value: "RECURRING", label: "Recurring", icon: "autorenew" },
    { value: "ONE_TIME", label: "One time", icon: "event" },
  ],
  "options.durationType",
);

export const SEARCH_KIND_OPTIONS: IconSelectOption[] = [
  { value: "text", label: "Title, description, ID", icon: "title", i18nKey: "incidents.searchTypeText" },
  { value: "openSearchId", label: "Database ID", icon: "fingerprint", i18nKey: "incidents.searchTypeDatabaseId" },
];

export const PAGE_SIZE_OPTIONS: IconSelectOption<number>[] = [
  { value: 25, label: "25", icon: "format_list_bulleted" },
  { value: 50, label: "50", icon: "view_list" },
  { value: 100, label: "100", icon: "table_rows" },
];
